import * as React from 'react';

import {Button} from 'shells/button/button';

import {handleCall} from '../../../../phone/handle-call';

import {CellString} from './string';
import type {Phone} from './types';

type Props = Phone & {
    type: string;
    isHidden?: boolean;
};

export function CellPhone(props: Props) {
    const phoneCallerTypeValue =
        typeof NutshellFrontendSettings !== 'undefined' && NutshellFrontendSettings.phonecaller_type
            ? NutshellFrontendSettings.phonecaller_type
            : '';

    const callButtonId = `${props.entityId}-list-call-button`;

    const shouldShowCallLink = phoneCallerTypeValue && props.value.valueRaw !== null;

    return (
        <>
            {shouldShowCallLink ? (
                <Button
                    id={callButtonId}
                    variant='text-primary'
                    size='small'
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();

                        handleCall(
                            props.value.value,
                            props.value.valueRaw,
                            phoneCallerTypeValue,
                            props.entityId,
                            callButtonId
                        );
                    }}
                >
                    {props.value.value}
                </Button>
            ) : (
                // If a call integration is not enabled, just render the phone number as a string (this was the way it was before)
                <CellString value={props.value.value} type={props.type} isHidden={props.isHidden} />
            )}
        </>
    );
}
